export enum EnvironmentalVars {
    APPSETTINGS = '__appSettings',
    KEYCLOAK_URL = 'keycloakUrl',
    KEYCLOAK_REALM = 'keycloakRealm',
    KEYCLOAK_CLIENT = 'keycloakClient',
    SUPPORT_SERVICE_PREFIX = 'supportServicePrefix',
    BUILD_ENV = 'buildEnv',
    TARGET = 'target',
    BASE_URL = 'baseUrl'
}

export interface BuildInfo {
    version: string;
    date: string;
}

export interface IAppEnvironment {
    production: boolean;
    onPremise: boolean;
    environment: string;
    appName: string;
    apiURL: string;
    keycloak: any;
    buildInfo: BuildInfo;
}
